import React from "react";
import { ExternalLink } from "components/ExternalLink";
import {
  CodeBlock,
  CopyableCodeLine,
} from "onboarding/components/NumberedStep";
import { KB_URL_BASE } from "onboarding/constants";
import { track } from "utils/track";

const KNOWLEDGEBASE_URL = `${KB_URL_BASE}/apm_tracing/python/install/`;

const pythonInstructions = props => {
  const { agentRecorderToken, serviceName, selectedOperatingSystem } = props;
  if (selectedOperatingSystem !== "linux") return null;
  return [
    {
      precedingContent: (
        <div>
          The Python agent is provided as a module that provides middleware for
          common frameworks. See the quick instructions below, or{" "}
          <ExternalLink href={KNOWLEDGEBASE_URL}>
            check out our documentation for more details
          </ExternalLink>.
        </div>
      ),
      title: "Install the Python agent",
      content: (
        <div onClick={_ => track("Copied the Python APM downloader script")}>
          <CopyableCodeLine shell>pip install appoptics-apm</CopyableCodeLine>
        </div>
      ),
    },
    {
      title: (
        <span>
          The service key is provided via an environment variable. Make sure
          this is available in the environment where your application is
          running:
        </span>
      ),
      content: (
        <div onClick={_ => track("Copied the Python APM installer script")}>
          <CopyableCodeLine shell>
            export APPOPTICS_SERVICE_KEY={agentRecorderToken}:{serviceName}
          </CopyableCodeLine>
        </div>
      ),
    },
    {
      title: `
        Import the AppOptics agent and attach it to your web application.
        Here's an example for Flask:
      `,
      content: (
        <div>
          <CodeBlock language="python">
            from appoptics_apm.middleware import AppOpticsApmMiddleware<br />
            # the flask app<br />
            app = Flask(__name__)<br />
            app.wsgi_app = AppOpticsApmMiddleware(app.wsgi_app)
          </CodeBlock>
          <p>
            Using another framework?{" "}
            <ExternalLink href={`${KNOWLEDGEBASE_URL}#enabling-the-agent`}>
              Check out the docs
            </ExternalLink>{" "}
            for instructions on Django and other frameworks.
          </p>
          <p>
            A few seconds after you restart your application, the agent will be
            connected to AppOptics.
          </p>
        </div>
      ),
    },
  ];
};

export default pythonInstructions;
